import React, { FC, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import { TGetAllStoreProductsData } from "core/models/store-products.model";
import { correctUploadPath } from "core/utils/image-path-correction";
import { CartControls } from "components/common/CartControls";
import NoImg from "assets/img/noImage.png";

import Style from "./Style.module.scss";

type TProductDetailItem = {
  label: string;
  value: React.ReactNode;
};

const ProductDetails: FC = () => {
  const location = useLocation<{ product: TGetAllStoreProductsData }>();
  const product = location.state?.product;

  /* ---------- Images ---------- */
  const images =
    product.files?.length > 0
      ? product.files.map(
          (file) =>
            `${process.env.REACT_APP_UPLOAD_SERVER_PATH}/${correctUploadPath(
              file,
            )}`,
        )
      : [NoImg];

  /* ---------- Product Details ---------- */
  const productDetails: TProductDetailItem[] = useMemo(
    () => [
      { label: "نوع محصول :", value: product.productTypeTitle },
      { label: "توضیحات :", value: product.description },
      {
        label: "قیمت :",
        value: `${product.price.toLocaleString("fa-IR")} ریال`,
      },
    ],
    [product],
  );

  if (!product) {
    return <div className={Style.notFound}>محصولی یافت نشد</div>;
  }

  return (
    <div className={Style.wrapper}>
      {/* ---------- Swiper ---------- */}
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={12}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        dir="rtl"
        className={Style.swiper}
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <img
              src={img}
              alt={`${product.title}-${index}`}
              className={Style.swiperImage}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* ---------- Details ---------- */}
      <div className={Style.details}>
        <h1 className={Style.title}>{product.title}</h1>

        {productDetails.map(({ label, value }) => (
          <div key={label} className={Style.infoRow}>
            <span className={Style.label}>{label}</span>
            <span className={Style.value}>{value}</span>
          </div>
        ))}

        {/* ---------- Cart ---------- */}
        <div className={Style.cartActions}>
          <CartControls product={product} variant="details" />
        </div>
      </div>
    </div>
  );
};

export { ProductDetails };
